.radioCard {
    border-width: 1px;
    border-color: var(--mantine-color-dark-3);

    &:hover {
        border-color: var(--mantine-color-primary-4);
    }

    &[data-checked] {
        border-color: var(--mantine-primary-color-4);
    }
}

.styledInput {
    margin-top: 0.5rem;
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-dark-3);
    background: var(--mantine-color-dark-5);
}

.summary {
    border: 1px solid var(--mantine-color-dark-3);
    border-radius: var(--mantine-radius-sm);
    background: var(--mantine-color-dark-5);
}
